<template>
  <div class="wt-linked-fields-media-link">
    <div
      class="wt2-text-field -media-link -storyboard-text"
      :class="{ '-with-link': !!value }"
      @click="setMediaLink"
    >
      <div class="-storyboard-input-title" v-if="!!value">{{ label }}:</div>
      <span :class="['wticon', 'wticon-link2']" v-if="!value" />
      <input placeholder="Linked Media" :value="value" tabindex="-1" />
      <div
        class="-remove-link"
        title="Remove Media Link"
        @click="removeSceneMediaLink"
        v-if="!!value"
      >
        <i :class="['wticon', 'wticon-close_x']" />
      </div>
    </div>
    <linked-fields-tags-browser
      v-if="showLinkedFieldsBrowser"
      :linkedFields="linkedFieldsSchema"
      @cancel="closeLinkedFieldsBrowser"
      @selected="sceneMediaLinkSelected"
      :urlsOnly="true"
      :options="linkedFieldsOptions"
    />
  </div>
</template>

<script>
import LinkedFieldsTagsBrowser from 'components/linkedFields/LinkedFieldsTagsBrowser.vue';

export default {
  name: 'LinkedFieldsMediaLink',
  props: ['value', 'label'],
  components: {
    LinkedFieldsTagsBrowser,
  },
  data() {
    return {
      showLinkedFieldsBrowser: false,
      linkedFieldsOptions: {
        value: null,
      },
    };
  },
  computed: {
    linkedFieldsSchema() {
      return app.linkedFieldsSchema;
    },
  },
  methods: {
    closeLinkedFieldsBrowser() {
      this.showLinkedFieldsBrowser = false;
    },
    setMediaLink() {
      this.linkedFieldsOptions.value = this.value;
      this.showLinkedFieldsBrowser = true;
    },
    removeSceneMediaLink(e) {
      this.$emit('input', null);
      e.stopPropagation();
    },
    sceneMediaLinkSelected(payload) {
      this.$emit('input', payload.value);
      this.closeLinkedFieldsBrowser();
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-linked-fields-media-link {
  .-media-link {
    cursor: pointer;
    .wticon {
      font-size: 17px;
    }
    input {
      pointer-events: none;
      color: #06a9f4;
      &::placeholder {
        color: #06a9f4;
      }
    }
    .wticon {
      color: #06a9f4;
    }
    &.-with-link {
      input {
        padding-left: 70px;
      }
    }
    .-remove-link {
      position: absolute;
      right: 5px;
      top: 12px;
      cursor: pointer;

      i {
        position: static;
        transform: none;
        left: inherit;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.75);
      }

      &:hover {
        i {
          color: rgba(0, 0, 0, 1);
        }
      }
    }
  }
}

.wt-custom-overlay-fields .wt-linked-fields-media-link .-media-link {
  &.-with-link input {
    padding-left: 70px;
  }
  input {
    background: transparent;
    padding-left: 40px;
  }
}

.-storyboard-input-title {
  position: absolute;
  bottom: 10px;
  left: 5px;
  width: 45px;
  display: flex;
  align-items: center;
  pointer-events: none;
  font-size: 14px;
}
</style>
